'use strict';

export default {
    /**
     * Gets the current tier
     * @param {Array} tiers
     * @param {String|Number} quantity
     */
    currentTier(tiers, quantity) {
        if (!tiers.length || quantity <= this.upperLimit(tiers)) {
            return null;
        }

        return _.find(tiers, item => {
            return quantity <= this.upperLimit(tiers, item);
        });
    },

    /**
     * Gets the upper limit for a tier
     * @param {Array} tiers
     * @param {Object} tier
     */
    upperLimit(tiers, tier) {

        if (!tier) {
            return tiers[0].lower_limit - 1;
        }


        let currentIndex = tiers.indexOf(tier),
            nextTier = tiers[currentIndex + 1];

        if (nextTier) {
            return nextTier.lower_limit - 1;
        }

        return 9999999999999;
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/Services/Variant.js